const validatePhone = phone => {
  const validPhone = new RegExp('^[0-9]{9,13}$')
  if (phone && phone.length > 0 && !validPhone.test(phone)) return false
  return true
}

export default validatePhone
